import {post} from 'axios';

const service = {
    pembayaran: async(body) => {
        let uri = '/peserta/uploads/buktibayar';
        let url = process.env.REACT_APP_API_URL + uri;
        let token = localStorage.getItem('token');
        
        // let token = localStorage.getItem('token') || '';

        let config = {
            // withCredentials: true,
            'Authorization': 'Bearer ' + token,
            headers: {
                'Content-Type': 'multipart/form-data',
                // 'Authorization': 'Bearer ' + token
            }
        }

        const consume = await post(url, body, config);
        return consume;
    },
    berkas: async(body) => {
        let id_user = localStorage.getItem('id_user') || '';
        let uri = '/peserta/uploads/dokumenPendaftaran/' + id_user;
        let url = process.env.REACT_APP_API_URL + uri;
        let token = localStorage.getItem('token');
        
        // let token = localStorage.getItem('token') || '';

        let config = {
            // withCredentials: true,
            'Authorization': 'Bearer ' + token,
            headers: {
                'Content-Type': 'multipart/form-data',
                // 'Authorization': 'Bearer ' + token
            }
        }

        const consume = await post(url, body, config);
        return consume;
    },
    biodata: async(body) => {
        let uri = '/peserta/isi-form';
        let url = process.env.REACT_APP_API_URL + uri;
        let token = localStorage.getItem('token');

        let config = {
            // withCredentials: true,
            'Authorization': 'Bearer ' + token,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }

        const consume = await post(url, body, config);
        return consume;
    }
}

export default service